<template>
  <hm-content class="micro-goods-list">
    <div class="table-panel flex flex-start mb10">
      <el-input
        class="mr10 flex-1"
        clearable
        v-model.trim="searchCondition.receiptSn"
        placeholder="请输入订单号"
        size="small"
      ></el-input>
      <el-input
        clearable
        v-model.trim="searchCondition.queryKey"
        placeholder="请输入收货人姓名/手机号"
        size="small"
        class="mr10 flex-1"
      ></el-input>
      <el-input
        class="mr10 flex-1"
        clearable
        v-model.trim="searchCondition.shareMemberMobile"
        placeholder="请输入推荐人手机号"
        size="small"
      ></el-input>
      <el-input
        class="mr10 flex-1"
        clearable
        v-model.trim="searchCondition.goodsKey"
        placeholder="请输入商品货号/条码"
        size="small"
      ></el-input>
      <el-select
        clearable
        v-model="searchCondition.deliveryType"
        placeholder="请选择配送方式"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="门店自提" value="mdzt"></el-option>
        <el-option label="快递发货" value="kdfh"></el-option>
        <el-option label="同城配送" value="tcps"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.belongShopId"
        placeholder="搜索/选择门店"
        size="small"
        filterable
        class="mr10 flex-1"
      >
        <el-option
          :label="v.shopName"
          :value="v.shopId"
          v-for="(v, i) in shopList.records"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.orderType"
        placeholder="请选择订单类型"
        size="small"
        filterable
        class="mr10 flex-1"
      >
        <el-option label="微店订单" value="wshop"></el-option>
        <el-option label="砍价订单" value="kjdd"></el-option>
        <el-option label="拼团订单" value="ptdd"></el-option>
        <el-option label="秒杀订单" value="mshd"></el-option>
        <el-option label="兑换订单" value="dhdd"></el-option>
        <el-option label="积分兑换订单" value="integral_order"></el-option>
        <el-option label="代客下单-当面付" value="smg_faceToFace"></el-option>
        <el-option label="代客下单-网推" value="smg_netPush"></el-option>
      </el-select>
    </div>
    <div class="flex flex-start mb10">
      <el-select
        clearable
        v-model="searchCondition.payMode"
        placeholder="请选择支付方式"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="未支付" value="no_pay"></el-option>
        <el-option label="0元订单" value="0_pay"></el-option>
        <el-option label="微信支付" value="wx_pay"></el-option>
        <el-option label="支付宝支付" value="ali_pay"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.orderState"
        placeholder="请选择订单状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="待付款" value="createOrder"></el-option>
        <el-option label="待发货" value="payOrder"></el-option>
        <el-option label="已发货" value="deliverOrder"></el-option>
        <el-option label="已收货" value="takeOrder"></el-option>
        <el-option label="已评价" value="pushOrder"></el-option>
        <el-option label="已取消" value="delOrder"></el-option>
        <el-option label="有退货退款" value="returnOrder"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.cardType"
        placeholder="请选择会员类型"
        size="small"
        class="mr10"
        filterable
      >
        <el-option
          :label="v.typeName"
          :value="v.cardTypeId"
          v-for="(v, i) in vipCardTypeList.records"
          :key="i"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择下单时间单段"
        end-placeholder="请选择下单时间单段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class="mr10"
      ></el-date-picker>
      <!-- <el-select
        clearable
        v-model="searchCondition.isOverseas"
        placeholder="是否海外订单"
        size="small"
        class="mr10"
        filterable
      >
        <el-option label="国内订单" value="no"></el-option>
        <el-option label="海外订单" value="yes"></el-option>
      </el-select> -->

      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出订单</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="outputDetailOrder"
        :loading="isOutputing"
        >导出订单明细</el-button
      >
    </div>
    <div style="fontSize:17px;fontWeight:600">
      <span class="mr20">应付金额:{{ orderCenterList.payPrice }}</span>
      <span>已付金额:{{ orderCenterList.actuallyPrice }}</span>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="orderCenterList.storeOrderBasicInfoModelPage.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="订单号"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="isOverseas"
          label="是否海外购订单"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.isOverseas === 'yes'">海外购订单</span>
            <span v-else>国内订单</span>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="orderType"
          label="订单类型"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
            <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
            <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
            <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
            <span v-if="scope.row.orderType === 'smg_faceToFace'"
              >代客下单-当面收款</span
            >
            <span v-if="scope.row.orderType === 'smg_netPush'"
              >代客下单-网络推送</span
            >
            <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
            <span v-if="scope.row.orderType === 'integral_order'"
              >积分兑换订单</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="purchaseTime"
          label="下单时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendTime"
          label="发货时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="收货人姓名/手机号"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row.receiverName }}/{{ scope.row.receiverMobile }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payPrice"
          label="应付金额"
          width="130"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType === 'integral_order'">
              <span v-if="scope.row.payPrice">¥{{ scope.row.payPrice }}+</span>
              <span>{{ scope.row.integralPoint }}积分 </span>
            </div>
            <span v-else>¥{{ scope.row.payPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actuallyPrice"
          label="实付金额"
          width="130"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.orderType === 'integral_order'">
              <span v-if="scope.row.actuallyPrice"
                >¥{{ scope.row.actuallyPrice }}+</span
              >
              <span>{{ scope.row.integralPoint }}积分 </span>
            </div>
            <span v-else>¥{{ scope.row.actuallyPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payMode"
          label="支付方式"
        >
          <template slot-scope="scope">
            <span class="status danger" v-if="scope.row.payMode === 'no_pay'"
              >未支付</span
            >
            <span class="status danger" v-if="scope.row.payMode === '0_pay'"
              >0元订单</span
            >
            <span class="status danger" v-if="scope.row.payMode === 'wx_pay'"
              >微信支付</span
            >
            <span class="status danger" v-if="scope.row.payMode === 'ali_pay'"
              >支付宝支付</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliveryType"
          label="配送方式"
        >
          <template slot-scope="scope">
            <span class="status blue" v-if="scope.row.deliveryType === 'mdzt'"
              >门店自提</span
            >
            <span
              class="status"
              style="cursor:pointer;"
              v-if="scope.row.deliveryType === 'kdfh'"
              :class="scope.row.orderState === 'deliverOrder' ? 'blue' : 'gray'"
              @click="orderDetail(scope.row)"
              >快递发货</span
            >
            <span class="status blue" v-if="scope.row.deliveryType === 'tcps'"
              >同城配送</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="指定门店"
          prop="shopName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderState"
          label="订单状态"
        >
          <template slot-scope="scope">
            <span
              class="status blue"
              v-if="scope.row.orderState === 'createOrder'"
              >待付款</span
            >
            <span class="status blue" v-if="scope.row.orderState === 'payOrder'"
              >待发货</span
            >
            <span
              class="status blue"
              v-if="scope.row.orderState === 'deliverOrder'"
              >已发货</span
            >
            <span
              class="status blue"
              v-if="scope.row.orderState === 'takeOrder'"
              >已收货</span
            >
            <span
              class="status blue"
              v-if="scope.row.orderState === 'pushOrder'"
              >已评价</span
            >
            <span class="status blue" v-if="scope.row.orderState === 'delOrder'"
              >已取消</span
            >
            <span
              class="status blue"
              v-if="scope.row.orderState === 'returnOrder'"
              >有退货退款</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="typeName"
          label="会员类型"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="orderSource"
          label="订单来源"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.orderSource === 'wxShop'">微店订单</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="推荐人机构"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberName"
          label="推荐人姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberMobile"
          label="推荐人手机号"
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="orderCenterList.storeOrderBasicInfoModelPage.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <el-dialog
        :title="title"
        :visible.sync="innerVisible"
        append-to-body
        width="70%"
      >
        <div v-if="type === 'cancle'">
          <el-form
            label-width="80px"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
          >
            <el-form-item label="取消原因" prop="cancelMsg">
              <el-input
                size="small"
                clearable
                v-model.trim="ruleForm.cancelMsg"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="type === 'tcps'">
          <el-form label-width="80px">
            <el-form-item label="请输入配送员信息">
              <el-input
                clearable
                size="small"
                v-model.trim="deliveryMsg"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="table mb20" v-if="type === 'send'">
          <div class="table-header flex">
            <div class="flex-1 text-center">订单编号</div>
            <div class="flex-1 text-center">收货人</div>
            <div class="flex-1 text-center">手机号</div>
            <div class="flex-1 text-center">收货地址</div>
            <div class="flex-1 text-center">配送方式</div>
            <div class="flex-1 text-center">物流单号</div>
          </div>
          <div class="table-body">
            <div
              class="flex table-row item-center"
              v-for="(v, index) in [detailsOrder.order]"
              :key="index"
            >
              <div class="flex-1 text-center">{{ v.receiptSn }}</div>
              <div class="flex-1 text-center">{{ v.receiverName }}</div>
              <div class="flex-1 text-center">{{ v.receiverMobile }}</div>
              <div class="flex-1 text-center">
                {{ v.deliveryAddress }}
              </div>
              <div class="flex-1 text-center">
                <el-input
                  style="width:150px;"
                  clearable
                  v-model.trim="companyCode"
                  placeholder="请输入快递公司"
                  size="small"
                  class="mr10"
                ></el-input>
              </div>
              <div class="flex-1">
                <el-input
                  style="width:150px;"
                  clearable
                  v-model.trim="expressOrderSn"
                  placeholder="请输入物流单号"
                  size="small"
                  class="mr10"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="table mb20" v-if="type === 'mdzt'">
          <div class="table-header flex">
            <div class="flex-1 text-center">提货人</div>
            <div class="flex-1 text-center">手机号</div>
            <div class="flex-1 text-center">提货门店</div>
            <div class="flex-1 text-center">提货单号</div>
          </div>
          <div class="table-body">
            <div
              class="flex table-row item-center"
              v-for="(v, index) in [detailsOrder.order]"
              :key="index"
            >
              <div class="flex-1 tac">{{ v.receiverName }}</div>
              <div class="flex-1 tac">{{ v.receiverMobile }}</div>
              <div class="flex-1 tac">{{ v.shopName }}</div>
              <div class="flex-1 tac">
                <el-input
                  clearable
                  v-model.trim="billNo"
                  placeholder="请输入提货单号"
                  size="small"
                  class="mr10"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="sure('ruleForm')"
            >确定</el-button
          >
          <el-button size="small" @click="innerVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <div slot="title">
        <span class="mr10">订单详情</span>
        <span class="form-item-tip" style="color: #fF0000"
          >当前订单状态：{{ orderSta }}</span
        >
      </div>
      <div class="content">
        <div class="progress" v-if="delOrder">
          <el-steps :active="active" align-center>
            <el-step title="创建订单" :description="createOrderTime"></el-step>
            <el-step title="支付订单" :description="payOrderTime"></el-step>
            <el-step
              title="平台配货发货"
              :description="deliverOrderTime"
            ></el-step>
            <el-step title="确认收货" :description="takeOrderTime"></el-step>
            <el-step title="完成评价" :description="pushOrderTime"></el-step>
          </el-steps>
        </div>
        <div class="flex flex-between p20" v-if="delOrder">
          <div>
            <el-button
              :disabled="disabled"
              type="primary"
              size="small"
              @click="openSendDialog(detailsOrder.order.deliveryType)"
              >去发货</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="sureArrive"
              :disabled="delivery"
              >确认送达</el-button
            >
            <el-button
              v-if="
                detailsOrder.orderStatus[detailsOrder.orderStatus.length - 1]
                  .orderStatus === 'createOrder'
              "
              type="primary"
              size="small"
              @click="openCancleOrderDialog"
              >取消订单</el-button
            >
          </div>
          <!-- <div>
            <el-select
              clearable
              v-model="belongShopId"
              placeholder="请选择门店"
              size="small"
              filterable
              class="mr10"
            >
              <el-option
                :label="v.shopName"
                :value="v.shopId"
                v-for="(v, i) in shopList.records"
                :key="i"
              ></el-option>
            </el-select>
            <el-button
              :disabled="!belongShopId"
              type="primary"
              size="small"
              @click="designate"
              >重新指派</el-button
            >
          </div> -->
        </div>
        <ul class="info-list">
          <li class="mb20">
            <div class="flex flex-wrap">
              <div class="title mr10">基本信息</div>
              <el-tag
                size="mini"
                effect="plain"
                color="#FFEEF6"
                v-if="detailsOrder.order.isOverseas === 'yes'"
                >海外购</el-tag
              >
            </div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="发货单流水号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="会员姓名"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberMobile"
                  label="会员手机号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="payMode"
                  label="支付方式"
                >
                  <template slot-scope="scope">
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'no_pay'"
                      >未支付</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === '0_pay'"
                      >0元订单</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'wx_pay'"
                      >微信支付</span
                    >
                    <span
                      class="status danger"
                      v-if="scope.row.payMode === 'ali_pay'"
                      >支付支付</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderSource"
                  label="订单来源"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderSource === 'wxShop'"
                      >微店订单</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderType"
                  label="订单类型"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                    <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                    <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                    <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                    <span v-if="scope.row.orderType === 'smg_faceToFace'"
                      >代客下单-当面收款</span
                    >
                    <span v-if="scope.row.orderType === 'smg_netPush'"
                      >代客下单-网络推送</span
                    >
                    <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                    <span v-if="scope.row.orderType === 'integral_order'"
                      >积分兑换订单</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="mb20">
              <el-table stripe border :data="[detailsOrder.order]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="deliveryType"
                  label="配送方式"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.deliveryType === 'mdzt'"
                      >门店自提</span
                    >
                    <span v-if="scope.row.deliveryType === 'kdfh'"
                      >快递发货</span
                    >
                    <span v-if="scope.row.deliveryType === 'tcps'"
                      >同城配送</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="detailsOrder.order.deliveryType === 'mdzt'"
                  header-align="center"
                  align="center"
                  prop="billNo"
                  label="提货单号"
                ></el-table-column>
                <el-table-column
                  v-else
                  header-align="center"
                  align="center"
                  prop="expressOrderSn"
                  label="物流单号"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="自动确认收货时间"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopName"
                  label="指定信息"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="spuName"
                  label="活动信息"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderRemark"
                  label="订单备注"
                ></el-table-column>

                <el-table-column
                  width="150"
                  header-align="center"
                  align="center"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="small"
                      type="text"
                      @click="editOrderRemark(scope.row)"
                      >编辑备注</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </li>
          <li class="mb20">
            <div class="title">收货人信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverName"
                label="收货人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiverMobile"
                label="手机号码"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="邮政编码"
              ></el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="deliveryAddress"
                label="收货地址"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.deliveryProvince
                    }}{{ scope.row.deliveryAddress }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                width="150"
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    @click="editReceiver(scope.row)"
                    >修改收货人信息</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="flex flex-between">
              <div class="title">商品信息</div>
              <div
                class="flex flex-end item-center"
                v-if="
                  detailsOrder.order.payMode !== 'no_pay' &&
                    isBtn('tuikuan:false')
                "
              >
                <span class="pointer mr10" @click="batchReturn">
                  <span class="hmicon icon-jianhuopeihuo"> </span>
                  批量退款
                </span>
              </div>
            </div>

            <el-table
              border
              :data="detailsOrder.orderGoods"
              @selection-change="getCheckedReturn"
              size="small"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                type="selection"
                width="50"
                header-align="center"
                align="center"
                :selectable="checkSelectable"
                v-if="
                  detailsOrder.order.payMode !== 'no_pay' &&
                    isBtn('tuikuan:false')
                "
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsImg"
                label="商品图片"
              >
                <template slot-scope="scope">
                  <div>
                    <div
                      class="flex flex-center item-center"
                      v-if="scope.row.returnType !== 'no'"
                    >
                      <!-- 仅退款 -->
                      <img
                        v-if="scope.row.refundReturnType === 'money'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                        alt=""
                      />

                      <!-- 退货退款 -->
                      <img
                        v-if="scope.row.refundReturnType === 'refund'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                        alt=""
                      />

                      <!-- 退运费 -->
                      <img
                        v-if="scope.row.refundReturnType === 'deliver'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                        alt=""
                      />
                    </div>

                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'yes'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                      alt=""
                    />
                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'doing'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                      alt=""
                    />
                    <div
                      class="flex flex-center item-center"
                      :class="
                        scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                      "
                    >
                      <div>
                        <img
                          style="width:100px;height:100px;"
                          v-if="scope.row.goodsImg"
                          :src="scope.row.goodsImg"
                          alt=""
                        />
                        <div style="width:100%">
                          <el-tag
                            style="width:100%"
                            size="mini"
                            effect="plain"
                            type="success"
                            v-if="scope.row.isGift === 'gift'"
                            >赠 品</el-tag
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="商品名称/品牌"
              >
                <template slot-scope="scope">
                  <p>{{ scope.row.spuName }}</p>
                  <p>品牌: {{ scope.row.brandName }}</p>
                  <el-tag type="warning"
                    >{{
                      scope.row.spuType === "virtual" ? "虚拟" : "实物"
                    }}商品</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="价格/货号"
              >
                <template slot-scope="scope">
                  <p>价格: {{ scope.row.totalPrice }}</p>
                  <p>货号: {{ scope.row.goodsSn }}</p>
                  <p>条码: {{ scope.row.barCode }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="净重/毛重"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.netWeight">
                    净重: {{ scope.row.netWeight }}
                  </p>
                  <p v-if="scope.row.grossWeight">
                    毛重: {{ scope.row.grossWeight }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="规格"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="数量"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="小计"
              >
                <template slot-scope="scope">
                  <p>
                    {{ (scope.row.totalPrice * scope.row.goodsNum).toFixed(2) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      detailsOrder.order.payMode !== 'no_pay' &&
                        isBtn('tuikuan:false')
                    "
                  >
                    <el-button
                      v-if="
                        (scope.row.spuType === 'virtual' &&
                          scope.row.memberLaunchRefund === 'yes') ||
                          scope.row.spuType !== 'virtual'
                      "
                      :disabled="scope.row.returnType !== 'no'"
                      size="small"
                      class="danger"
                      type="text"
                      @click="refund(scope.row)"
                      >退款</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">费用信息</div>
            <el-table stripe border :data="[detailsOrder.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="商品合计"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.totalPrice }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="taxFee"
                label="税费"
                v-if="detailsOrder.order.isOverseas === 'yes'"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.taxFee }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliverMoney"
                label="运费"
              >
                <template slot-scope="scope">
                  <p>￥{{ scope.row.deliverMoney }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliverCouponMoney"
                label="运费券抵扣"
              >
                <template slot-scope="scope">
                  <span class="status primary"
                    >-￥{{ scope.row.deliverCouponMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="couponMoney"
                label="优惠券"
                width="220"
              >
                <template slot-scope="scope">
                  <div
                    class="primary"
                    v-for="(v, i) in scope.row.orderCouponInfoModels"
                    :key="i"
                  >
                    {{ v.ruleName }} {{ v.couponCode }}
                  </div>
                  <div class="status primary">
                    -￥{{ scope.row.couponMoney }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activeMoney"
                label="积分抵扣"
                v-if="detailsOrder.order.orderType === 'integral_order'"
              >
                <template slot-scope="scope">
                  <span class="status danger"
                    >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="activeMoney"
                label="活动优惠"
                v-else
              >
                <template slot-scope="scope">
                  <span class="status danger"
                    >-￥{{ scope.row.activeMoney }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="actuallyPrice"
                label="实付金额"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.orderType === 'integral_order'"
                    class="status danger"
                  >
                    <span v-if="scope.row.actuallyPrice"
                      >¥{{ scope.row.actuallyPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                    >¥{{ scope.row.actuallyPrice }}</span
                  >
                </template>
                <!-- <template slot-scope="scope">
                  <span class="status danger"
                    >￥{{ scope.row.actuallyPrice }}</span
                  >
                </template> -->
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payPrice"
                label="应付金额"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.orderType === 'integral_order'"
                    class="status danger"
                  >
                    <span v-if="scope.row.payPrice"
                      >¥{{ scope.row.payPrice }}+</span
                    >
                    <span>{{ scope.row.integralPoint }}积分 </span>
                  </div>
                  <span v-else class="status danger"
                    >¥{{ scope.row.payPrice }}</span
                  >
                </template>
                <!-- <template slot-scope="scope">
                  <span class="status danger">￥{{ scope.row.payPrice }}</span>
                </template> -->
              </el-table-column>
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">操作信息</div>
            <el-table
              stripe
              border
              :data="detailsOrder.orderStatus"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="operatorAccount"
                label="操作账号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operatorName"
                label="操作人"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.operatorName === null">
                    {{ scope.row.createBy }}
                  </div>
                  <div v-else>
                    {{ scope.row.operatorName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="操作时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="订单状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'createOrder'"
                    >待付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'payOrder'"
                    >待发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'deliverOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'takeOrder'"
                    >已收货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'pushOrder'"
                    >已评价</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'delOrder'"
                    >已取消</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'returnOrder'"
                    >有退货退款</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="付款状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'createOrder'"
                    >未付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'payOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'deliverOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'takeOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'pushOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'delOrder'"
                    >已取消</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="发货状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'createOrder'"
                    >未发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'payOrder'"
                    >未发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'deliverOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'takeOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'pushOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'delOrder'"
                    >已取消</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="remark"
                label="备注"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="beizhu(scope.row)"
                      >添加备注</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
            </el-table>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="logisticsInfoVisible"
    >
      <div slot="title">
        <span class="mr10">物流快递</span>
      </div>
      <ul class="logistics-list">
        <li class="flex mb20">
          <div class="flex-1">
            <div class="title">发件人信息</div>
            <div class="content-item">
              <span>操作人名称：</span>
              <span class="info">{{ showLogsistics.order.createBy }}</span>
            </div>
            <!-- <div class="content-item">
              <span>发件人地址：</span>
              <span class="info"
                >武汉市东西湖技术开发区光谷步行街A地 块B区4楼403室</span
              >
            </div> -->
            <div class="content-item">
              <span>操作人电话：</span>
              <span class="info">{{ showLogsistics.order.phone }}</span>
            </div>
          </div>
          <div class="flex-1">
            <div class="title">收件人信息</div>
            <div class="content-item">
              <span>收件人名称：</span>
              <span class="info">{{ showLogsistics.order.receiverName }}</span>
            </div>
            <div class="content-item">
              <span>发收件人地址：</span>
              <span class="info">{{
                showLogsistics.order.deliveryAddress
              }}</span>
            </div>
            <div class="content-item">
              <span>收件人电话：</span>
              <span class="info">{{
                showLogsistics.order.receiverMobile
              }}</span>
            </div>
          </div>
        </li>
        <li class="mb20">
          <div class="title">订单明细</div>
          <div class="mb20">
            <el-table stripe border :data="[showLogsistics.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberMobile"
                label="会员手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payMode"
                label="支付方式"
              >
                <template slot-scope="scope">
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'no_pay'"
                    >未支付</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === '0_pay'"
                    >0元订单</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'wx_pay'"
                    >微信支付</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'ali_pay'"
                    >支付支付</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSource"
                label="订单来源"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderType"
                label="订单类型"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                  <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                  <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                  <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                  <span v-if="scope.row.orderType === 'smg_faceToFace'"
                    >代客下单-当面收款</span
                  >
                  <span v-if="scope.row.orderType === 'smg_netPush'"
                    >代客下单-网络推送</span
                  >
                  <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                  <span v-if="scope.row.orderType === 'integral_order'"
                    >积分兑换订单</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="form-item-tip">
            备注：{{ showLogsistics.order.orderRemark }}
          </div>
        </li>
        <li>
          <div class="title">物流信息</div>
          <div>
            <!-- <el-steps direction="vertical" :active="1">
              <el-step title="已签收" icon="el-icon-edit"></el-step>
               <el-step
                :title="v.AcceptTime"
                :description="v.AcceptStation"
                v-for="(v, i) in showLogsistics.courierInfo.traces"
                :key="i"
              ></el-step>
              <el-step title="已揽件" description="包裹正在等待揽收"></el-step>
              <el-step title="已下单" ></el-step>
             
            </el-steps> -->

            <div class="div-bg bg-white">
              <div
                style="height: 0.5rem;width: 100%;backgroundColor:#f7f7f7"
              ></div>
              <!--物流跟踪-->
              <div style="paddingBottom: 0.5rem;">
                <div
                  class="bg-white"
                  style="width: 92%; marginLeft: 4%;margin: auto;paddingLeft: 15px;paddingRight: 15px;"
                >
                  <div>
                    <div class="track-rcol">
                      <div class="track-list">
                        <ul>
                          <div
                            v-for="(item, index) in showLogsistics.courierInfo
                              .traces"
                            :key="index"
                          >
                            <li :class="index === 0 ? 'first' : ''">
                              <div></div>
                              <i class="node-icon"></i>
                              <span class="txt">{{ item.AcceptStation }}</span>
                              <span class="time">{{ item.AcceptTime }}</span>
                            </li>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="logisticsInfoVisible = false"
          size="small"
          type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogResetForm"
    >
      <el-form
        :model="ruleFormReset"
        :rules="rulesResetrules"
        ref="ruleFormReset"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="订单备注"
          prop="orderRemark"
          v-if="editType === 'remark'"
        >
          <el-input
            size="small"
            type="textarea"
            clearable
            placeholder="请输入订单备注"
            v-model="ruleFormReset.orderRemark"
          ></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item label="收货人" prop="receiverName">
            <el-input
              size="small"
              clearable
              placeholder="请输入收货人"
              v-model="ruleFormReset.receiverName"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="receiverMobile">
            <el-input
              size="small"
              clearable
              placeholder="请输入手机号码"
              v-model="ruleFormReset.receiverMobile"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="邮政编码" prop="receiverMobile">
            <el-input
              size="small"
              clearable
              placeholder="请输入邮政编码"
              v-model="ruleFormReset.receiverMobile"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="收货人详细地址" prop="deliveryAddress">
            <el-input
              size="small"
              type="textarea"
              clearable
              placeholder="请输入详细地址"
              v-model="ruleFormReset.deliveryAddress"
            ></el-input>
          </el-form-item>
        </div>

        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm"
            >提交</el-button
          >
          <el-button size="small" @click="dialogResetForm = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title="退款"
      :close-on-click-modal="false"
      :visible.sync="dialogRetrun"
      :before-close="returnClose"
    >
      <el-form
        :model="ruleFormRetrun"
        :rules="rulesRetrunrules"
        ref="ruleFormRetrun"
        label-width="80px"
      >
        <el-form-item label="退款方式" prop="returnType">
          <el-select
            size="small"
            filterable
            class="mr10"
            clearable
            v-model="ruleFormRetrun.returnType"
            placeholder="请选择退款方式"
          >
            <el-option label="仅退款" value="money"> </el-option>
            <el-option
              label="退货退款"
              value="refund"
              v-if="detailsOrder.order.isSend === 'yes'"
            >
            </el-option>
            <el-option
              label="退运费"
              value="deliver"
              v-if="detailsOrder.order.deliveryType !== 'mdzt'"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="退运费"
          prop="returnDeliverMoney"
          v-if="detailsOrder.order.deliveryType !== 'mdzt'"
        >
          <div>最多可退{{ useReturnDeliverMoney }}元</div>
          <el-input
            clearable
            v-model.trim="ruleFormRetrun.returnDeliverMoney"
            @input="filterGt0OrFixed2('returnDeliverMoney')"
            placeholder="请输入退运费金额"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleFormRetrun.returnType === 'deliver'"
          label="退款备注"
          prop="returnContext"
          :rules="{
            required: true,
            message: '请输入退款备注',
            trigger: 'blur'
          }"
        >
          <el-input
            clearable
            maxlength="150"
            :autosize="{ minRows: 5, maxRows: 17 }"
            type="textarea"
            v-model.trim="ruleFormRetrun.returnContext"
            placeholder="请输入退款备注"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="退款备注" prop="returnContext" v-else>
          <el-input
            clearable
            maxlength="150"
            :autosize="{ minRows: 5, maxRows: 17 }"
            type="textarea"
            v-model.trim="ruleFormRetrun.returnContext"
            placeholder="请输入退款备注"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReturn" size="small" type="primary"
          >确 认</el-button
        >
        <el-button @click="returnClose" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  mixins: [outPutMixin],
  data() {
    const validatorFunc = (rule, val, callback) => {
      if (val > this.useReturnDeliverMoney) {
        return callback(new Error(`运费最多可退${this.useReturnDeliverMoney}`));
      }
      callback();
    };
    return {
      ruleFormRetrun: {
        returnType: "",
        returnDeliverMoney: "",
        returnContext: ""
      },
      rulesRetrunrules: {
        returnType: {
          required: true,
          message: "请选择退款方式",
          trigger: "change"
        },
        returnDeliverMoney: [
          {
            required: true,
            message: "请输入退运费金额",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "change"
          }
        ]
        // returnContext: {
        //   required: this.ruleFormRetrun.returnType === "deliver",
        //   message: "请输入退款备注",
        //   trigger: "change"
        // }
      },
      dialogRetrun: false,
      ruleFormReset: {
        orderId: "",
        orderRemark: "",
        receiverName: "",
        receiverMobile: "",
        deliveryAddress: ""
      },
      rulesResetrules: {
        receiverName: {
          required: true,
          message: "请输入收货人",
          trigger: "change"
        },
        receiverMobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        },
        deliveryAddress: {
          required: true,
          message: "请输入详细地址",
          trigger: "change"
        }
      },
      editType: "",
      dialogResetForm: false,
      receiptSn: "",
      expressOrderSn: "",
      companyCode: "",
      isPreview: false,
      deliveryMsg: "",
      delOrder: true,
      ruleForm: {
        cancelMsg: ""
      },
      orderSta: "",
      createOrderTime: "",
      payOrderTime: "",
      deliverOrderTime: "",
      takeOrderTime: "",
      pushOrderTime: "",
      delivery: false,
      disabled: false,
      active: 2,
      belongShopId: "",
      orderId: "",
      billNo: "",
      type: "",
      title: "",
      dialogVisible: false,
      logisticsInfoVisible: false,
      innerVisible: false,
      checkedRow: {},
      batchCondition: {},
      searchCondition: {
        applyDate: []
      },
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      rules: {
        cancelMsg: [
          { required: true, message: "请输入取消原因", trigger: "blur" }
        ]
      },
      returnGoods: [],
      useReturnDeliverMoney: 0
      // totalPrice: "",
      // actuallyPrice: ""
    };
  },
  created() {
    // let nowDate = new Date();
    // let date = {
    //   year: nowDate.getFullYear(),
    //   month: nowDate.getMonth() + 1,
    //   date: nowDate.getDate()
    // };
    // if (date.month >= 1 && date.month <= 9) {
    //   date.month = "0" + date.month;
    // }
    // if (date.date >= 0 && date.date <= 9) {
    //   date.date = "0" + date.date;
    // }
    // let systemDate = date.year + "-" + date.month + "-" + date.date;

    this.searchCondition.applyDate = [
      `${this.getDay(-7)} 00:00:00`,
      `${this.getDay(0)} 23:59:59`
    ];
    this.getParamsCookie();
    this.queryList();
    this.queryShopList();
    this.queryCardTypeList();
  },
  computed: mapGetters([
    "orderCenterList",
    "detailsOrder",
    "shopList",
    "showLogsistics",
    "orderAllCenterList",
    "vipCardTypeList"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    }
  },
  methods: {
    getDay(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      let m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    checkSelectable(row) {
      if (row.spuType === "virtual" && row.memberLaunchRefund !== "yes") {
        return false;
      } else {
        return row.returnType === "no";
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleFormRetrun[prop] = this.ruleFormRetrun[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormRetrun[prop] = this.ruleFormRetrun[prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.ruleFormRetrun[prop] = this.ruleFormRetrun[prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.ruleFormRetrun[prop] = this.ruleFormRetrun[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleFormRetrun[prop] = this.ruleFormRetrun[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.ruleFormRetrun[prop].indexOf(".") < 0 &&
        this.ruleFormRetrun[prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleFormRetrun[prop] = parseFloat(this.ruleFormRetrun[prop]);
      }
    },
    resetRetrunForm() {
      setTimeout(() => {
        this.$refs.ruleFormRetrun.resetFields();
      }, 0);
    },
    returnClose() {
      this.dialogRetrun = false;
      this.resetRetrunForm();
    },
    async submitReturn() {
      const valid = await this.$refs.ruleFormRetrun.validate();
      if (valid) {
        let params = this.ruleFormRetrun;
        params.confirmReturnDeliverMoney = params.returnDeliverMoney;
        let returnList = [];
        this.returnGoods.forEach((v, i) => {
          if (i === 0) {
            returnList.push(
              Object.assign(params, {
                receiptSn: v.receiptSn,
                skuId: v.skuId,
                orderGoodsId: v.orderDetailsId,
                returnTranslate: "门店退货"
              })
            );
          } else {
            let param = {};
            for (let key in params) {
              if (
                key !== "confirmReturnDeliverMoney" &&
                key !== "returnDeliverMoney"
              ) {
                param[key] = params[key];
              }
            }
            returnList.push(
              Object.assign(param, {
                receiptSn: v.receiptSn,
                skuId: v.skuId,
                orderGoodsId: v.orderDetailsId,
                returnTranslate: "门店退货"
              })
            );
          }
        });
        const { code } = await this.$store.dispatch(
          "orderReturnPut",
          returnList
        );
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.resetRetrunForm();
          this.returnGoods = [];
          this.dialogRetrun = false;
          this.details();
          this.queryList();
        }
      }
    },
    async submitForm() {
      const valid = await this.$refs.ruleFormReset.validate();
      if (valid) {
        let params = this.ruleFormReset;
        params.editType = this.editType;

        const { code } = await this.$store.dispatch("editRemark", params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogResetForm = false;
          this.details();
        }
      }
    },
    editReceiver(row) {
      for (let key in this.ruleFormReset) {
        this.ruleFormReset[key] = row[key];
      }
      this.title = "收货人信息";
      this.editType = "deliveryInfo";
      this.dialogResetForm = true;
    },
    editOrderRemark(row) {
      for (let key in this.ruleFormReset) {
        this.ruleFormReset[key] = row[key];
      }
      this.title = "订单备注";
      this.editType = "remark";
      this.dialogResetForm = true;
    },
    tableRowClassName({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },
    queryShopList() {
      this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    queryCardTypeList() {
      this.$store.dispatch("queryVipCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    send() {},
    sureArrive() {
      this.$store
        .dispatch("sureArrive", {
          orderId: this.orderId
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
            this.details();
          }
        });
    },
    openCancleOrderDialog() {
      this.innerVisible = true;
      this.type = "cancle";
      this.title = "取消订单";
    },
    openSendDialog(row) {
      // 如果是美团 直接调接口
      // 如果是快递

      // if (row === "mdzt") {
      //   this.innerVisible = true;
      //   this.type = "mdzt";
      //   this.title = "门店自提";
      // } else if (row === "kdfh") {
      //   this.innerVisible = true;
      //   this.type = "send";
      //   this.title = "快递发货";
      // } else if (row === "tcps") {
      //   this.innerVisible = true;
      //   this.type = "tcps";
      //   this.title = "送货上门";
      // }
      this.$router.push({
        name: "ShippingOrderList"
      });
    },
    sure(formName) {
      if (this.type === "cancle") {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$store
              .dispatch("addOrder", {
                orderId: this.orderId,
                cancelMsg: this.ruleForm.cancelMsg
              })
              .then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: " 操作成功",
                    type: "success"
                  });
                  this.innerVisible = false;
                  this.details();
                }
              });
          } else {
            return false;
          }
        });
      } else if (this.type === "send") {
        this.$store
          .dispatch("deliverOrder", {
            orderId: this.orderId,
            companyCode: this.companyCode,
            expressOrderSn: this.expressOrderSn,
            receiptSn: this.receiptSn
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.innerVisible = false;
              this.details();
            }
          });
      } else if (this.type === "mdzt") {
        this.$store
          .dispatch("addOrder", {
            orderId: this.orderId,
            billNo: this.billNo
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.innerVisible = false;
              this.details();
            }
          });
      } else if (this.type === "tcps") {
        this.$store
          .dispatch("addOrder", {
            orderId: this.orderId,
            deliveryMsg: this.deliveryMsg
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.innerVisible = false;
              this.details();
            }
          });
      }
    },
    submitsearchCondition() {
      let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
      batchCondition.wxshopCategoryId =
        batchCondition.wxshopCategoryId[
          batchCondition.wxshopCategoryId.length - 1
        ];
      batchCondition.spuIdList = this.checkedRow;
      this.$store.dispatch("batchEdit", batchCondition).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
          this.dialogVisible = false;
        }
      });
    },
    addGoods() {
      this.$router.push({ name: "AddMicroShopGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditMicroShopGoods",
        query: {
          spuId: row.spuId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          spuId: row.spuId
        };
        if (type) {
          actionName = "batchEdit";
          params = {
            spuIdList: row,
            delFlag: 1
          };
        }
        this.$store.dispatch(actionName, params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    queryAllDetailList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      searchCondition.pageSize = 9999999;
      searchCondition.pageNo = 1;
      return this.$store.dispatch("detailOrderList", searchCondition);
    },
    outputDetailOrder() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllDetailList()
          .then(res => {
            const list = res.result.records;

            list.forEach(v => {
              // if (v.orderType === "wshop") {
              //   v.orderType = "微店订单";
              // } else if (v.orderType === "ptdd") {
              //   v.orderType = "拼团订单";
              // } else if (v.orderType === "kjdd") {
              //   v.orderType = "砍价订单";
              // } else if (v.orderType === "mshd") {
              //   v.orderType = "秒杀订单";
              // }
              // if (v.orderSource === "wxShop") {
              //   v.orderSource = "微信";
              // }
              if (v.payMode === "no_pay") {
                v.payMode = "未支付";
              } else if (v.payMode === "wx_pay") {
                v.payMode = "微信支付";
              } else if (v.payMode === "ali_pay") {
                v.payMode = "支付支付";
              } else if (v.payMode === "0_pay") {
                v.payMode = "0元订单";
              }

              // if (v.deliveryType === "mdzt") {
              //   v.deliveryType = "门店自提";
              // } else if (v.deliveryType === "kdfh") {
              //   v.deliveryType = "快递发货";
              // } else if (v.deliveryType === "tcps") {
              //   v.deliveryType = "同城配送";
              // }
              if (v.orderState === "createOrder") {
                v.orderStatus = "待付款";
              } else if (v.orderState === "payOrder") {
                v.orderStatus = "待发货";
              } else if (v.orderState === "deliverOrder") {
                v.orderStatus = "已发货";
              } else if (v.orderState === "takeOrder") {
                v.orderStatus = "已收货";
              } else if (v.orderState === "pushOrder") {
                v.orderStatus = "同城配送";
              } else if (v.orderState === "delOrder") {
                v.orderStatus = "已取消";
              } else if (v.orderState === "returnOrder") {
                v.orderStatus = "售后订单";
              }
            });
            const tHeader = [
              "订单号",
              "分类名称",
              "品牌名称",
              "商品名称",
              "商品货号",
              "商品规格",
              "商品条码",
              "商品数量",
              "商品原价",
              "商品折后单价",
              "商品折后总价",
              "下单时间",
              "收货人",
              "收货人手机",
              "收货区域",
              "收货人地址",
              "会员手机",
              "支付状态",
              "订单状态",
              "订单总价实付金额",
              "推荐人id",
              "推荐人手机号",
              "推荐人姓名",
              "推荐人所属机构",
              "订单指定门店",
              "商品退货进度",
              "退货金额",
              "订单备注"
            ];
            const filterVal = [
              "receiptSn",
              "categoryName",
              "brandName",
              "spuName",
              "goodsSn",
              "specIdGroupName",
              "barCode",
              "goodsNum",
              "totalPrice",
              "realPrice",
              "realTotalPrice",
              "createTime",
              "receiverName",
              "receiverMobile",
              "deliveryProvince",
              "deliveryAddress",
              "memberPhone",
              "payMode",
              "orderState",
              "actuallyPrice",
              "referId",
              "memberMobile",
              "memberName",
              "departName",
              "shopName",
              "returnType",
              "returnPrice",
              "orderRemark"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "订单明细" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res.result.storeOrderBasicInfoModelPage.records;

            list.forEach(v => {
              if (v.orderType === "wshop") {
                v.orderType = "微店订单";
              } else if (v.orderType === "ptdd") {
                v.orderType = "拼团订单";
              } else if (v.orderType === "kjdd") {
                v.orderType = "砍价订单";
              } else if (v.orderType === "mshd") {
                v.orderType = "秒杀订单";
              } else if (v.orderType === "smg_faceToFace") {
                v.orderType = "代客下单-当面收款";
              } else if (v.orderType === "smg_netPush") {
                v.orderType = "代客下单-网络推送";
              } else if (v.orderType === "integral_order") {
                v.orderType = "积分兑换订单";
              }

              if (v.orderSource === "wxShop") {
                v.orderSource = "微信";
              }
              if (v.payMode === "no_pay") {
                v.payMode = "未支付";
              } else if (v.payMode === "wx_pay") {
                v.payMode = "微信支付";
              } else if (v.payMode === "ali_pay") {
                v.payMode = "支付支付";
              } else if (v.payMode === "0_pay") {
                v.payMode = "0元订单";
              }

              if (v.deliveryType === "mdzt") {
                v.deliveryType = "门店自提";
              } else if (v.deliveryType === "kdfh") {
                v.deliveryType = "快递发货";
              } else if (v.deliveryType === "tcps") {
                v.deliveryType = "同城配送";
              }
              if (v.orderState === "createOrder") {
                v.orderStatus = "待付款";
              } else if (v.orderState === "payOrder") {
                v.orderStatus = "待发货";
              } else if (v.orderState === "deliverOrder") {
                v.orderStatus = "已发货";
              } else if (v.orderState === "takeOrder") {
                v.orderStatus = "已收货";
              } else if (v.orderState === "pushOrder") {
                v.orderStatus = "同城配送";
              } else if (v.orderState === "delOrder") {
                v.orderStatus = "已取消";
              } else if (v.orderState === "returnOrder") {
                v.orderStatus = "售后订单";
              }
            });
            const tHeader = [
              "订单号",
              "订单类型",
              "下单时间",
              "收货人姓名",
              "收货人手机号",
              "应付金额",
              "运费",
              "使用优惠券金额",
              "活动优惠金额",
              "实付金额",
              "支付方式",
              "配送方式",
              "指定门店",
              "发货单号",
              "物流单号",
              "发货人",
              "订单状态",
              "会员手机号",
              "会员类型",
              "订单来源"
            ];
            const filterVal = [
              "receiptSn",
              "orderType",
              "purchaseTime",
              "receiverName",
              "receiverMobile",
              "payPrice",
              "deliverMoney",
              "couponMoney",
              "activeMoney",
              "actuallyPrice",
              "payMode",
              "deliveryType",
              "shopName",
              "deliverSn",
              "expressOrderSn",
              "opeer",
              "orderStatus",
              "memberMobile",
              "cardTypeName",
              "orderSource"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "订单列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryAllList() {
      const params = {
        pageSize: 999999999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllOrderCenterList", params);
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.starTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";

      Object.assign(params, searchCondition);
      this.setParamsCookie();
      const actionName = queryAll
        ? "queryAllOrderCenterList"
        : "queryOrderCenterList";
      if (this.isArray(searchCondition.applyDate)) {
        return this.$store.dispatch(actionName, params);
      } else {
        this.$message({
          message: "请选择下单时间段！",
          type: "warning"
        });
      }
    },
    setParamsCookie() {
      setCookie({
        key: "orderListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "orderListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },

    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    getCheckedReturn(selection) {
      this.returnGoods = selection;
    },
    refund(row) {
      this.dialogRetrun = true;
      this.returnGoods = [row];
    },
    batchReturn() {
      if (this.returnGoods.length) {
        this.dialogRetrun = true;
      } else {
        this.$message({
          message: "请选择退款商品",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
      // this.searchCondition.startTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[0]
      //     : "";
      // this.searchCondition.endTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[1]
      //     : "";

      // const params = {
      //   pageSize: this.pageSize,
      //   pageNo: this.currentPage
      // };

      // Object.assign(params, this.searchCondition);
      // this.$store.dispatch("queryOrderCenterList", params);
    },
    details() {
      return this.$store
        .dispatch("detailOrder", {
          orderId: this.orderId
        })
        .then(res => {
          let orderSta =
            res.result.orderStatus[res.result.orderStatus.length - 1];
          let flag = false;
          res.result.orderGoods.map(v => {
            if (v.returnType === "no") {
              flag = true;
            }
          });
          if (flag) {
            let listStatus = [];
            res.result.orderStatus.forEach(v => {
              if (v.orderStatus !== "returnOrder") {
                listStatus.push(v);
              }
            });
            orderSta = listStatus[listStatus.length - 1];
          }

          if (orderSta.orderStatus === "createOrder") {
            this.active = 1;
            this.delOrder = true;
            this.disabled = true;
            this.delivery = true;
            this.orderSta = "待付款";
          } else if (orderSta.orderStatus === "payOrder") {
            this.active = 2;
            this.delOrder = true;
            this.disabled = false;
            this.delivery = true;
            this.orderSta = "待发货";
          } else if (orderSta.orderStatus === "deliverOrder") {
            this.active = 3;
            this.delOrder = true;
            this.orderSta = "已发货";
            this.delivery = false;
            this.disabled = true;
          } else if (orderSta.orderStatus === "takeOrder") {
            this.active = 4;
            this.delOrder = true;
            this.orderSta = "已收货";
            this.delivery = true;
            this.disabled = true;
          } else if (orderSta.orderStatus === "pushOrder") {
            this.active = 5;
            this.delOrder = true;
            this.orderSta = "已评价";
            this.delivery = true;
            this.disabled = true;
          } else if (orderSta.orderStatus === "delOrder") {
            this.delOrder = false;
            this.orderSta = "已取消";
          } else if (orderSta.orderStatus === "returnOrder") {
            this.delOrder = false;
            this.orderSta = "有退货退款";
          }

          res.result.orderStatus.forEach(v => {
            if (v.orderStatus === "createOrder") {
              this.createOrderTime = v.createTime;
            }
            if (v.orderStatus === "payOrder") {
              this.payOrderTime = v.createTime;
            }
            if (v.orderStatus === "deliverOrder") {
              this.deliverOrderTime = v.createTime;
            }
            if (v.orderStatus === "takeOrder") {
              this.takeOrderTime = v.createTime;
            }
            if (v.orderStatus === "pushOrder") {
              this.pushOrderTime = v.createTime;
            }
          });
          let returnDeliver = 0;
          res.result.orderGoods.forEach(v => {
            returnDeliver += v.returnDeliverMoney || 0;
          });
          this.useReturnDeliverMoney = (
            res.result.order.deliverMoney -
            returnDeliver -
            res.result.order.deliverCouponMoney
          ).toFixed(2);
          this.ruleFormRetrun.returnDeliverMoney = this.useReturnDeliverMoney;
          this.queryShopList();
        });
    },
    close() {
      this.dialogVisible = false;

      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    handleClose(done) {
      done();
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    toDetails(row) {
      //  if(v.orderState === 'createOrder'){
      //           v.orderState="待付款"
      //         }else if(v.orderState === 'payOrder'){
      //           v.orderStatus="待发货"
      //         }else if(v.orderState === 'deliverOrder'){
      //           v.orderState="已发货"
      //         }else if(v.orderState === 'takeOrder'){
      //           v.orderState="已收货"
      //         }else if(v.orderState === 'pushOrder'){
      //           v.orderState="同城配送"
      //         }else if(v.orderState === 'delOrder'){
      //           v.orderState="已取消"
      //         }

      this.orderId = row.orderId;
      this.receiptSn = row.receiptSn;
      this.dialogVisible = true;
      this.details();

      // .then(res => {
      //   let orderSta =
      //     res.result.orderStatus[res.result.orderStatus.length - 1];

      //   if (orderSta.orderStatus === "createOrder") {
      //     this.active = 1;
      //     this.orderSta = "待付款";
      //   } else if (orderSta.orderStatus === "payOrder") {
      //     this.active = 2;
      //     this.orderSta = "待发货";
      //   } else if (orderSta.orderStatus === "deliverOrder") {
      //     this.active = 3;
      //     this.orderSta = "已发货";
      //     this.disabled = true;
      //   } else if (orderSta.orderStatus === "takeOrder") {
      //     this.active = 4;
      //     this.orderSta = "已收货";
      //     this.delivery=true
      //     this.disabled = true;
      //   } else if (orderSta.orderStatus === "pushOrder") {
      //     this.active = 5;
      //     this.orderSta = "已评价";
      //     this.delivery=true
      //     this.disabled = true;
      //   }else if(orderSta.orderStatus === "delOrder"){

      //     this.delOrder=false
      //     this.orderSta = "已取消";
      //   }
      //   res.result.orderStatus.forEach(v => {
      //     if (v.orderStatus === "deliverOrder") {
      //       this.deliverOrderTime = v.createTime;
      //     }
      //     if (v.orderStatus === "takeOrder") {
      //       this.takeOrderTime = v.createTime;
      //     }
      //     if (v.orderStatus === "pushOrder") {
      //       this.pushOrderTime = v.createTime;
      //     }
      //   });

      //   this.queryShopList();
      // });
    },
    resetRuleForm() {
      this.createOrderTime = "";
      this.payOrderTime = "";
      this.deliverOrderTime = "";
      this.takeOrderTime = "";
      this.pushOrderTime = "";
      this.belongShopId = "";
      this.ruleForm.cancelMsg = "";
    },
    designate() {
      this.$store
        .dispatch("appointOutlet", {
          orderId: this.orderId,
          belongShopId: this.belongShopId
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.details();
            this.queryList();
          }
        });
    },
    orderDetail(row) {
      if (row.orderState === "deliverOrder") {
        this.$store
          .dispatch("showLogsistics", {
            orderId: row.orderId
          })
          .then(res => {
            if (res.code === "0") {
              this.logisticsInfoVisible = true;
            }
          });
      }
    }
  }
};
</script>
<style lang="scss">
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}
// .el-table .tuikuan {
//   background: rgba(255, 240, 240, 1);
//   border: 1px solid rgba(255, 0, 0, 1);
//   z-index: 9999999;
// }

.content {
  .el-step.is-center .el-step__description {
    padding: 0;
  }
}
</style>
<style scoped lang="scss">
.only-tuikuan {
  opacity: 0.3;
  // background: rgba(255, 255, 255, 1);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.warning-tuikuan {
  position: absolute;
  left: -50px;
  top: 0;
}
.track-rcol {
  .track-list {
    position: relative;
  }
  ul li {
    list-style: none;
    font-size: 14px;
    line-height: 14px;
  }
  ul {
    padding-left: 1.5rem;
  }
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 14px;
  border-left: 1px solid #d9d9d9;
  color: #999;
}
.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}
.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}
.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 10px;
  z-index: 2;
  height: 10px;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}
.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}
.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}
.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}
.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}
.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}
.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}

.tac {
  text-align: center;
}
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}

.content {
  margin: -20px;
  .progress {
    background: #f7f7f7;
    padding: 20px 0;
  }
}
.info-list {
  padding: 0 20px;
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 20px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}

.content-item {
  line-height: 25px;
  color: #222;
  .info {
    color: #666666;
  }
}

.table {
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
</style>
